"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.programIcons = void 0;
var _types = require("../../types");
var _base = _interopRequireDefault(require("./base.svg"));
var _family = _interopRequireDefault(require("./family.svg"));
var _it = _interopRequireDefault(require("./it.svg"));
var _preferential = _interopRequireDefault(require("./preferential.svg"));
const programIcons = exports.programIcons = {
  [_types.EProgramType.BASE]: _base.default,
  [_types.EProgramType.FAMILY]: _family.default,
  [_types.EProgramType.IT]: _it.default,
  [_types.EProgramType.PREFERENTIAL]: _preferential.default
};